module.exports = __webpack_public_path__ + "static/media/orthotreat.fded8a23.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/orthotreat.webp
// module id = 857
// module chunks = 0